module.exports = function getResource(label, vars = []) {
    const resources = {
        allPhotos: 'All Photos',
        myPhotos: 'My Photos',
        addAPhoto: 'Add a Photo'
    };
    return resources[label];
};
